module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAwIiBoZWlnaHQ9IjYwMCI+PHBhdGggZmlsbD0iIzAwQTFERSIgZD0iTTAgMzAwaDEwMDB2MzAwSDB6Ii8+PHBhdGggZmlsbD0iI2VkMjkzOSIgZD0iTTAgMGgxMDAwdjMwMEgweiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDIwMGgxMDAwdjIwMEgweiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lux.svg
// module id = SRc4
// module chunks = 0